import {BaseDTO} from '../../../common/models/BaseDTO';
import {NameValueDTO} from '../../../common/models/NameValueDTO';
import {ProviderDTO} from '../../../ent/models/ProviderDTO';

export class CaseHospitalProviderLinkDTO extends BaseDTO {
  provider: ProviderDTO;
  providerRole: NameValueDTO;
  startDate: Date;
  endDate: Date;
}